<h1 mat-dialog-title>Download Report</h1>
<div mat-dialog-content>
  Your report is ready to download.
  <a [href]="url" (click)="onClickDownload()" target="_blank">Download Report</a>
</div>
